import PhoneInput from "react-phone-number-input";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

const VuiPhoneInput = ({ label, value, onChange, error, defaultCountry = "US" }) => {
  const handleKeyDown = (e) => {
    const digitsOnly = (value || "").replace(/\D/g, "");

    // allow navigation and deletion
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"];

    if (allowedKeys.includes(e.key)) return;

    // block typing if already 15 digits
    if (digitsOnly.length >= 15 && /\d/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <VuiBox>
      {label && (
        <VuiTypography variant="caption" ml={1}>
          {label}
        </VuiTypography>
      )}

      <VuiBox
        sx={{
          borderRadius: "14px",
          px: 1.25,
          py: 1.35,
          background: "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.03))",
          backdropFilter: "blur(8px)",
          border: error ? "1px solid rgba(255,0,0,0.6)" : "1px solid rgba(104, 102, 102, 0.3)",

          "& .PhoneInputInput": {
            color: "#1A1D1A !important",
          },

          "& .PhoneInputInput::placeholder": {
            color: "rgba(26,29,26,0.55) !important",
            opacity: 1,
          },
        }}
      >
        <PhoneInput
          defaultCountry={defaultCountry}
          value={value}
          onChange={onChange}
          international
          countryCallingCodeEditable={true}
          onKeyDown={handleKeyDown}
          inputProps={{
            maxLength: 16,
          }}
        />
      </VuiBox>

      {error && (
        <VuiTypography variant="caption" color="error" ml={1}>
          {error}
        </VuiTypography>
      )}
    </VuiBox>
  );
};

export default VuiPhoneInput;
